// Support Videos：点击卡片弹窗播放 YouTube

class SupportVideos extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.autoplay = this.dataset.autoplay === 'true';
    this.modal = this.querySelector('[data-sv-modal]');
    this.frame = this.querySelector('[data-sv-frame]');
    this.titleEl = this.querySelector('[data-sv-modal-title]');
    this._activeTrigger = null;

    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onCloseClick = this._onCloseClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);

    this.querySelectorAll('[data-sv-trigger]').forEach((btn) => {
      btn.addEventListener('click', this._onTriggerClick);
    });

    this.querySelectorAll('[data-sv-close]').forEach((btn) => {
      btn.addEventListener('click', this._onCloseClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-sv-trigger]').forEach((btn) => {
      btn.removeEventListener('click', this._onTriggerClick);
    });
    this.querySelectorAll('[data-sv-close]').forEach((btn) => {
      btn.removeEventListener('click', this._onCloseClick);
    });
    document.removeEventListener('keydown', this._onKeydown);
    this.close();
    this._initialized = false;
  }

  _onTriggerClick(e) {
    const trigger = e.currentTarget;
    const videoId = trigger.getAttribute('data-video-id');
    if (!videoId) return;

    this.open(videoId, {
      title: trigger.getAttribute('data-video-title') || '',
      trigger,
    });
  }

  _onCloseClick(e) {
    e.preventDefault();
    this.close();
  }

  _onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }

  open(videoId, { title = '', trigger = null } = {}) {
    if (!this.modal || !this.frame) return;

    this._activeTrigger = trigger;
    if (this.titleEl) {
      this.titleEl.textContent = title;
      this.titleEl.hidden = !title;
    }

    const params = new URLSearchParams({
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
      enablejsapi: '1',
    });

    if (this.autoplay) {
      params.set('autoplay', '1');
      // 弹窗由用户点击打开，多数浏览器允许带声自动播放；mute 作为兜底可按需再开
    }

    this.frame.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);

    const closeBtn = this.modal.querySelector('[data-sv-close-btn]');
    if (closeBtn) closeBtn.focus();
  }

  close() {
    if (!this.modal || !this.frame) return;
    if (!this.modal.classList.contains('is-open')) return;

    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.frame.src = '';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);

    if (this._activeTrigger) {
      this._activeTrigger.focus();
      this._activeTrigger = null;
    }
  }
}

if (!window.customElements.get('support-videos')) {
  window.customElements.define('support-videos', SupportVideos);
}
